import HTTP from '@/http';

const getDealerCampaigns = async (dealerId) => {
    const response = await new HTTP().get(`dealers/${dealerId}/platforms/snapchat/campaigns`);

    return response.data;
};

export default getDealerCampaigns;
